<!--
 * @Author: 曹捷
 * @Date: 2021-03-15 14:54:07
 * @LastEditors: 曹捷
 * @LastEditTime: 2021-09-02 16:31:32
 * @Description: 用户管理
-->
<template>
  <obitUniversalTable name="用户列表" :pagination="pagination" v-if="$fmt(['sys_normal_disable','sys_user_sex','sys_user_post','sys_staff_type'])">
    <template #search>
      <obit-search-form :params="params" :paramList="paramList" @search="pageQuery(true)">
      </obit-search-form>
    </template>
    <template #btn>
      <a-button @click="removeAll(rowSelection.selectedRows)" class="m-r-15">
        删除
      </a-button>
      <a-button @click="onOff(rowSelection.selectedRows,'off')" class="m-r-15">
        禁用
      </a-button>
      <a-button @click="onOff(rowSelection.selectedRows,'on')" class="m-r-15">
        启用
      </a-button>
      <a-button type="primary" @click="addDialog">
        <i class="iconfont icon-add-bold p-r-5"></i> 新 增
      </a-button>
    </template>
    <a-table :loading="pageLoading" rowKey="userId" :columns="tableColumns" :dataSource="pageDataList"
      :row-selection="rowSelection" :pagination="false" class="obit-atable" highlight-current-row
      :scroll="{ x: '100%' }" style="width: 100%">
      <template #sort="{record,index}">
        {{(pageParams.pageNum-1)*10+index+1}}
      </template>
      <template #dept="{record}">
        {{record.dept && record.dept.deptName || ''}}
      </template>
      <template #status="{record}" :key="record.userId">
        <obitSwitchUrl v-model:value="record.status" check="正常" uncheck="停用" activeValue="0" inactiveValue="1"
          :info="{ ajaxUrl:'system/user/batchChangeStatus', fieldName: 'status',ajaxType: 'post',data:{userIds:[record.userId]} }" @reload="pageQuery(true)">
        </obitSwitchUrl>
      </template>
      <template #operation="{ record}" :key="record.userId">
        <div>
          <a-button class="operation-btn" type="link" @click="details(record)" v-if="record.tenantSuperUser === false">查看</a-button>
          <a-button class="operation-btn" type="link" @click="editDialog(record)" v-if="record.tenantSuperUser === false">编辑</a-button>
          <a-button class="operation-btn" type="link" @click="savePassword(record)">修改密码</a-button>
          <a-button class="operation-btn" type="link" @click="remove(record)" v-if="record.tenantSuperUser === false">删除</a-button>
        </div>
      </template>
    </a-table>
  </obitUniversalTable>
  <userAdd :addType="pageType" v-model:open="pageVisable" v-if="pageVisable" :detailsInfo="detailsInfo" @reload="pageQuery">
  </userAdd>
  <userDetails v-model:open="pageDetailsVisable" v-if="pageDetailsVisable" :dataInfo="dataInfo" @reload="pageQuery">
  </userDetails>
  <resetPassword v-model:open="pageVisablePassword" v-if="pageVisablePassword" :userId="userId" @reload="pageQuery(true)">
  </resetPassword>
</template>

<script>
import { getCurrentInstance, inject, onMounted, reactive, toRefs } from 'vue'
import page from 'obit-wui/hook/page'
import userAdd from './userAdd.vue'
import userDetails from './userDetails.vue'
import resetPassword from './userReset.vue'
import obitSwitchUrl from '../../../components/obitSwitchUrl.vue'
export default {
  components: { userAdd, userDetails ,resetPassword,obitSwitchUrl},
  setup (props, contenxt) {
    let { proxy } = getCurrentInstance()
    let http = inject('http')
    let pageIns = page({
      url: 'system/user/pageList',
      key: 'userId',
      removeUrl: 'system/user/remove',
      beforeSuccess (data) {
        data.data && data.data.forEach(element => {
          element.roleNameAll = element.roles.join(', ')
        });
      }
    })
    let _data = reactive({
      userId: '',
      pageVisablePassword: false,
      pageDetailsVisable: false,
      dataInfo: {},
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          _data.rowSelection.selectedRows = selectedRows
          _data.rowSelection.selectedRowKeys = selectedRowKeys
        },
      },
      tableColumns: [
        { slots: { customRender: 'sort' }, title: '序号', width: 60 },
        { dataIndex: 'userName', title: '登录账号', width: 150 },
        { dataIndex: 'nickName', title: '用户姓名', width: 150 },
        { dataIndex: 'userRoleNameStrings', title: '所属角色', width: 150 },
        { slots: { customRender: 'dept' }, title: '所属部门', width: 200 },
        { dataIndex: 'staffType', customRender: ({ text, record, index }) => proxy.$fmt('sys_staff_type', text), title: '用户类型', width: 150 },
        { slots: { customRender: 'status' }, title: '状态', width: 100 },
        { title: '操作', slots: { customRender: 'operation' }, width: 300 },
      ],
      paramList: [
        { name: '账号', key: 'userName' },
        { name: '用户姓名', key: 'nickName' },
        {
          type: 'tree',
          key: 'deptId',
          name: '公司部门',
          children: 'children',
          valueName: 'id',
          label: 'label',
          customApi: true,
          url: 'sysGetTreeSelect',
        },
        { name: "用户类型", key: "staffType", type: "dict", dictCode: "sys_staff_type" },
      ],
    })
    let _methods = {
      details(item){
        _data.dataInfo = item
        _data.pageDetailsVisable = true
      },
      savePassword (item) {
        _data.userId = item.userId
        _data.pageVisablePassword = true
      },
      onOff(item,type){
        if (item===undefined||item.length === 0) {
          proxy.$message.warning('请至少选择一条要操作的数据')
          return
        }
        let arr = item.reduce((list, item) => {
          list.push(item.userId)
          return list
        }, [])
        proxy.$confirm({
          title: '提示',
          content: type==='off'?'是否禁用':'是否启用',
          cancelText: '取消',
          okText: '确认',
          onOk () {
            let param = {}
            param.userIds = arr
            param.status = type==='off'?'1':'0'
            proxy.$http.commonPost('system/user/batchChangeStatus', param).then((res) => {
              proxy.$message.success(type==='off'?'禁用成功':'启用成功')
              _data.rowSelection.selectedRows = []
              _data.rowSelection.selectedRowKeys = []
              pageIns._method.pageQuery()
            })
          },
        })
      },
      removeAll (item) {
        if (item===undefined||item.length === 0) {
          proxy.$message.warning('请至少选择一条要操作的数据')
          return
        }
        let arr = item.reduce((list, item) => {
          list.push(item.userId)
          return list
        }, [])
        proxy.$confirm({
          title: '提示',
          content: '是否全部删除',
          cancelText: '取消',
          okText: '确认',
          onOk () {
            let param = {}
            param.idList = arr
            proxy.$http.commonPost('system/user/removeAll', param).then((res) => {
              proxy.$message.success('删除成功')
              _data.rowSelection.selectedRows = []
              _data.rowSelection.selectedRowKeys = []
              pageIns._method.pageQuery()
            })
          },
        })
      }
    }
    onMounted(() => {
      pageIns._method.pageQuery()
    })
    return {
      ...toRefs(pageIns._data),
      ...pageIns._method,
      ...toRefs(_data),
      ..._methods,
    }
  },
}
</script>

<style>
</style>